import React, { useEffect, useState } from "react";

import { Table, Button, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";

import { TaxRate } from "../../bitmaker/schemas/Billing/TaxRate";

interface TaxRateSelectorContentProps {
  onCancel: () => void;
  onApply: (selectedTaxIds: number[]) => void;
  taxRates: TaxRate[];
  currentTaxIds: number[];
}

export const TaxRateSelectorContent: React.FC<TaxRateSelectorContentProps> = ({
  onCancel,
  onApply,
  taxRates,
  currentTaxIds,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] =
    useState<React.Key[]>(currentTaxIds);

  useEffect(() => {
    setSelectedRowKeys(currentTaxIds);
  }, [currentTaxIds]);

  const columns: ColumnsType<TaxRate> = [
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      render: (rate: number) => (
        <Tag color="blue">{(rate * 100).toFixed(2).replace(/\.00$/, "")}%</Tag>
      ),
      width: "20%",
    },
    {
      title: "Tax Name",
      dataIndex: "name",
      key: "name",
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys: React.Key[]) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  return (
    <div style={{ width: 400 }}>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={taxRates}
        pagination={false}
        size="small"
        rowKey="id"
      />
      <div className="flex justify-end gap-2 mt-4">
        <Button
          onClick={() => {
            setSelectedRowKeys(currentTaxIds);
            onCancel();
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={() => {
            onApply(selectedRowKeys as number[]);
          }}
        >
          Apply Taxes ({selectedRowKeys.length})
        </Button>
      </div>
    </div>
  );
};
